import { Component } from '@mycolorway/tao';
import 'next/stylesheets/components/feature-video-guide';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-feature-video-guide', {
  mixins: [eventListenerMixin],

  properties: {},

  connected() {
    this.dialog = this.querySelector('tr-dialog');
  },

  ready() {
    this.listenTo(this.querySelector('.close-dialog-btn'), 'click', this.onCloseButtonClick.bind(this));
    this.listenTo(this.querySelector('.desc-link'), 'click', this.onDescLinkClick.bind(this));
    this.listenTo(this.dialog, 'tr-dialog:closed', () => {
      this.close();
    });
    this.video = this.querySelector('video#feature-video');
    this.listenTo(this.video, 'play', this.onVideoPlay.bind(this), { once: true });
    this.listenTo(this.video, 'ended', this.onVideoEnded.bind(this), { once: true });
    this.autoplay();
    this.dialog.mdcDialog.scrimClickAction = '';
  },

  close() {
    this.dialog.close();
    const { currentTime, duration } = this.video;
    this.namespacedTrigger('closed', {
      detail: { currentTime, duration },
      bubbles: true,
    });
    this.remove();
  },

  autoplay() {
    if (this.video.autoplay) this.video.play();
  },

  onCloseButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.close();
  },

  onDescLinkClick() {
    this.namespacedTrigger('linkClicked', { bubbles: true });
    this.pause();
  },

  onVideoPlay() {
    console.debug('on video play');
    this.namespacedTrigger('play', { bubbles: true });
  },

  onVideoEnded() {
    console.debug('on video ended');
    this.namespacedTrigger('ended', { bubbles: true });
  },

  pause() {
    this.querySelector('#feature-video').pause();
  },

  disconnected() {
    this.stopListening();
  },
});
